import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export const toolbarTemplate = html `<slot></slot>`;
export class ToolbarComponent extends ChameleonElementMixin(FoundationElement) {
}
